import React from 'react';
import { Form, Button } from 'semantic-ui-react';
import { useForm } from "react-hook-form";
import './Form.css'

export default function FormValidation() {
    const { register, handleSubmit,reset, formState: { errors } } = useForm();
    const onSubmit = (data) => {
        //console.log(data);
            const formData = new FormData();
            formData.append('nome', data.nome);
            formData.append('cognome', data.cognome);      
            formData.append('email', data.email);     
            formData.append('telefono', data.cognome);    
            formData.append('messaggio', data.messaggio);

            let risp = "0";
            let params = {
                "nome": data.nome,
                "cognome": data.cognome,
                "email": data.email,
                "telefono" : data.telefono,
                "messaggio" : data.messaggio
              };
              
              let query = Object.keys(params)
                           .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                           .join('&');
              
              let url = 'backend/email/send_email.php?' + query;
              //let url = '../../backend/email/send_email.php'
            fetch(url, {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
                mode: 'no-cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'omit', // include, *same-origin, omit
                //body: formData,
                headers: {
                  'Content-Type': 'application/json'
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-
                })
                .then(function(response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.text()
                    }
                    throw new Error(response.statusText)
                    })
                    .then(function(response) {
                        //console.log(response);
                        risp = response;
                    })
                .then((responseSubmit) => {
                    reset({
                        nome: "",
                        cognome: "",
                        email: "",
                        telefono: "",
                        messaggio: ""
                      })
                    console.log('sending...', responseSubmit);
                    if (risp === "1") {
                        console.log('Sended');
                        alert("Messaggio inviato correttamente");
                    } else {
                        console.log('NOT Sended');
                        alert("Errore invio messaggio");
                    }
                })              
    }
    
    return (
        <div  className="formBlock">
            <Form  onSubmit={handleSubmit(onSubmit)}>
                <Form.Field>
                    <label>Nome *</label>
                    <input
                        placeholder='Nome'
                        type="text"
                        {...register("nome", { required: true, maxLength: 10 })}
                    />
                </Form.Field>
                {errors.nome && <p className="text-error">Per favore inserisci il tuo Nome</p>}
                
                <Form.Field>
                    <label>Cognome *</label>
                    <input
                        placeholder='Cognome'
                        type="text"
                        {...register("cognome", { required: true, maxLength: 10 })}
                    />
                </Form.Field>
                {errors.cognome && <p className="text-error">Per favore inserisci il tuo Cognome</p>}
                
                <Form.Field>
                    <label>Email *</label>
                    <input
                        placeholder='Email'
                        type="email"
                        {...register("email",
                            {
                                required: true,
                                pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            })}
                    />
                </Form.Field>
                {errors.email && <p className="text-error">Per favore inserisci la tua Email</p>}
                
                <Form.Field>
                <label> Telefono *</label>
                    <input
                            placeholder='Telefono'
                            type="number"
                            {...register("telefono", { required: true, minLength: 9 , maxLength: 15 })}
                    />                            
                </Form.Field>
                {errors.telefono && <p className="text-error">Per favore inserisci un numero di Telefono valido</p>}
                
                <Form.Field>
                <label> Messaggio *
                    <textarea
                            placeholder='Messaggio'
                            type="text"
                            {...register("messaggio", { required: true})}>
                    </textarea>                       
                </label>
                </Form.Field>
                {errors.messaggio && <p className="text-error">Per favore inserisci un Messaggio</p>}
                <Button className= "submitBtn" type='submit'>INVIA</Button>
            </Form>
        </div>
    )
}
